import {
  AdapterSource,
  DispatcherAuthPrefix,
  DispatcherCategoryService,
  DispatcherResource
} from 'modules/types/common';
import { getDispatcherUrl } from 'modules/utils/UrlUtils';
import { DFDHeaders } from 'serverTypes/authentication';
import { Category } from './types';

export const GET_PREDIABETES_VIDEOS = 'HEALTHTOOLS.GET_PREDIABETES_VIDEOS';
export const GET_PREDIABETES_VIDEOS_SUCCESS = 'HEALTHTOOLS.GET_PREDIABETES_VIDEOS_SUCCESS';
export const GET_PREDIABETES_VIDEOS_FAIL = 'HEALTHTOOLS.GET_PREDIABETES_VIDEOS_FAIL';

export const getPrediabetesVideo = (category: Category) => {
  return {
    type: GET_PREDIABETES_VIDEOS,
    payload: {
      client: 'dispatcher',
      request: {
        method: 'post',
        url: getDispatcherUrl(
          DispatcherCategoryService.UTILITY,
          DispatcherAuthPrefix.AUTHENTICATED,
          DispatcherResource.HEALTH_TOOLS_INFO
        ),
        headers: {
          [DFDHeaders.mhpAdapter]: AdapterSource.MHP
        },
        data: {
          language: category.language,
          platform: category.platform,
          category: 'prediabetes'
        }
      }
    }
  };
};
